let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1su9U")).then(() => parcelRequire('aIk0I'));